<template>
  <div class="admin-link-view">
    <Card dis-hover>
      <Alert type="info" show-icon style="margin-bottom:12px">动态链接支持地区条件匹配与默认回退。保存后生成可复制的短链。</Alert>

      <Row type="flex" justify="center" class="table-action-section">
        <Col span="12"><b>动态链接列表</b>
          <Poptip trigger="hover" placement="right">
            <Icon type="md-help-circle" style="margin-left:6px" />
            <div slot="content" style="max-width:320px; white-space:normal;">
              动态链接支持地区条件匹配与默认回退，保存后生成可复制的短链。
            </div>
          </Poptip>
        </Col>
        <Col span="8" style="text-align:right">
          <Input v-model="searchKey" placeholder="搜索链接名称" style="width:240px" @on-enter="doSearch" />
          <Button type="default" size="small" style="margin-left:8px" @click="doSearch">搜索</Button>
        </Col>
        <Col span="4" style="text-align:right">
          <Button type="primary" size="small" :disabled="listLoading" :loading="saving" @click="showCreate">新增链接</Button>
        </Col>
      </Row>

      <Table border :data="tableData" :columns="tableColumns" stripe :loading="listLoading"></Table>
      <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
          <Page show-total :total="totalCount" :page-size="pageSize" @on-change="changePage"></Page>
        </div>
      </div>
    </Card>

    <Modal width="960" v-model="editModal" title="新增/编辑动态链接" @on-ok="edit(true)" @on-cancel="edit(false)">
      <div class="edit-modal-body">
      <Form ref="dataModel" :model="dataModel" :rules="rules" :label-width="100">
        <Form-item label="链接名称" prop="name">
          <Input v-model="dataModel.name" placeholder="请输入名称"></Input>
        </Form-item>
        <Form-item label="链接描述" prop="description">
          <Input v-model="dataModel.description" placeholder="可选"></Input>
        </Form-item>
        <Form-item label="自定义短链" prop="shortCode">
          <Input v-model="dataModel.shortCode" placeholder="留空则自动生成随机短链">
            <span slot="prepend">{{ apiOrigin }}/{{ shortPrefix }}/</span>
          </Input>
        </Form-item>
        <Form-item label="启用状态" prop="status">
          <i-switch v-model="statusEnabled"></i-switch>
        </Form-item>

        <Divider>跳转规则</Divider>

        <Row>
          <Col span="24">
            <Button type="dashed" icon="md-add" @click="addDefaultRule" :disabled="hasDefaultRule">添加默认规则</Button>
            <Button type="dashed" icon="md-add" style="margin-left:8px" @click="addConditionalRule">添加条件规则</Button>
          </Col>
        </Row>

        <div v-for="(rule, idx) in dataModel.rules" :key="idx" class="rule-row">
          <Row :gutter="12">
            <Col span="4">
              <Tag color="blue">{{ rule.type === 'default' ? '默认规则' : '条件规则' }}</Tag>
            </Col>
            <Col span="12">
              <Input v-model="rule.url" placeholder="目标链接URL"></Input>
            </Col>
            <Col span="4">
              <Input v-model.number="rule.priority" placeholder="优先级"></Input>
            </Col>
            <Col span="4" style="text-align:right">
              <Button type="error" size="small" @click="removeRule(idx)">删除</Button>
            </Col>
          </Row>
          <Row v-if="rule.type==='conditional'" style="margin-top:8px">
            <Col span="24">
              <Row :gutter="8" style="margin-bottom:6px">
                <Col span="12">
                  <Input v-model="rule.regionFilter" placeholder="筛选省/市（仅用于查找）"></Input>
                </Col>
                <Col span="12" style="text-align:right">
                  <Button size="small" @click="expandAllRule(idx, true)">展开全部</Button>
                  <Button size="small" style="margin-left:6px" @click="expandAllRule(idx, false)">收起全部</Button>
                </Col>
              </Row>
              <div style="max-height:320px; overflow:auto; border:1px solid #e8eaec; padding:8px;">
                <Tree :data="rule.regionTree" show-checkbox @on-check-change="onRegionTreeChange(idx)"></Tree>
              </div>
            </Col>
          </Row>
          <Divider dashed></Divider>
        </div>
      </Form>
      </div>
    </Modal>

    <Modal width="300" v-model="destroyModal">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="information-circled"></Icon>
        <span>删除确认</span>
      </p>
      <div style="text-align:center; font-size:14px" >
        <p>链接：{{ destroyData ? destroyData.name : '-'}}</p>
        <p>将被删除且无法恢复，是否继续？</p>
      </div>
      <div slot="footer">
        <Button type="error" size="large" long @click="destroy(true)">删除</Button>
      </div>
    </Modal>
  </div>
  
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      configPublicBaseOrigin: '',
      configShortPrefix: 'r',
      dismissedTip: false,
      regionTreeAll: [],
      searchKey: '',
      editModal: false,
      destroyModal: false,
      destroyData: null,
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      listLoading: false,
      saving: false,
      deleting: false,
      tableColumns: [
        { title: 'ID', key: 'id', align: 'center' },
        { title: '链接名称', key: 'name', align: 'center' },
        {
          title: '规则类型', key: 'rules', align: 'center',
          render: (h, params) => {
            const rules = params.row.rules || [];
            const hasDefault = rules.find(r => r.type === 'default');
            const condCount = rules.filter(r => r.type === 'conditional').length;
            const text = `${hasDefault ? '默认' : ''}${condCount ? (hasDefault ? '+' : '') + '条件(' + condCount + ')' : ''}` || '-';
            return h('span', {}, text);
          }
        },
        {
          title: '目标链接', key: 'target', align: 'center',
          render: (h, params) => {
            const rules = params.row.rules || [];
            const def = rules.find(r => r.type === 'default');
            return h('span', {}, (def && def.url) || '-');
          }
        },
        // 添加访问数量列
        { title: '访问次数', key: 'visitCount', align: 'center' },
        {
          title: '状态', key: 'status', align: 'center',
          render: (h, params) => {
            const active = params.row.status === 'active';
            return h('i-switch', {
              props: { value: active },
              on: {
                'on-change': (val) => this.toggleStatus(params.index, val)
              }
            });
          }
        },

        { title: '创建时间', key: 'createdAt', align: 'center', render: (h, p) => h('span', {}, moment(p.row.createdAt).format('YYYY-MM-DD HH:mm:ss')) },
        {
          title: '操作', key: 'actions', align: 'center',
          render: (h, params) => {
            const url = `${this.apiOrigin}/${this.shortPrefix}/${params.row.shortCode || params.row.id}`;
            return h('div', [
              h('a', { 
                style: { color: '#2d8cf0', cursor: 'pointer', marginRight: '8px' },
                on: { click: () => this.showEdit(params.index) }
              }, '编辑'),
              h('a', { 
                style: { color: '#19be6b', cursor: 'pointer', marginRight: '8px' },
                on: { click: () => this.copyToClipboard(url) }
              }, '复制'),
              h('a', { 
                style: { color: '#ed4014', cursor: 'pointer' },
                on: { click: () => this.showDestroy(params.index) }
              }, '删除')
            ]);
          }
        }
      ],
      dataModel: { name: '', description: '', shortCode: '', rules: [], status: 'active' },
      rules: {
        name: [ { required: true, message: '名称不能为空', trigger: 'blur' } ],
        shortCode: [
          { pattern: /^[a-zA-Z0-9]{3,20}$/, message: '短链只能包含字母和数字，长度3-20位', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    statusEnabled: {
      get() { return this.dataModel.status === 'active'; },
      set(v) { this.dataModel.status = v ? 'active' : 'inactive'; }
    },
    hasDefaultRule() {
      return !!(this.dataModel.rules || []).find(r => r.type === 'default');
    },
    apiOrigin() {
      const root = this.$http && this.$http.options && this.$http.options.root ? this.$http.options.root : '';
      const m = root.match(/^https?:\/\/[^/]+/);
      return this.configPublicBaseOrigin || (m ? m[0] : (location.origin || ''));
    },
    shortPrefix() {
      return this.configShortPrefix || 'r';
    }
  },
  created() {
    this.changePage(1);
    try { this.dismissedTip = !!window.localStorage.getItem('linkTipDismissed'); } catch (e) {}
    this.$http.get('config').then((res) => {
      const cfg = res.data && res.data.data ? res.data.data : {};
      if (cfg.baseUrl) this.configPublicBaseOrigin = cfg.baseUrl;
      if (cfg.prefix) this.configShortPrefix = cfg.prefix;
    });
    this.$http.get('regions').then((res) => {
      const data = res.data && res.data.data ? res.data.data : {};
      const { tree = [] } = data;
      this.regionTreeAll = tree;
    });
  },
  methods: {
    doSearch() {
      this.changePage(1);
    },
    changePage(page) {
      this.currentPage = page;
      const offset = ((page || 1) - 1) * this.pageSize;
      const q = this.searchKey ? `&q=${encodeURIComponent(this.searchKey)}` : '';
      this.listLoading = true;
      this.$http.get(`admin/links?limit=${this.pageSize}&offset=${offset}${q}`).then((res) => {
        const data = res.data.data;
        this.tableData = data.rows || data.items || [];
        this.totalCount = data.count || data.total || 0;
      }).catch(() => {
        this.$Message.warning('列表加载失败');
      }).finally(() => { this.listLoading = false; });
    },
    showCreate() {
      this.dataModel = { name: '', description: '', shortCode: '', rules: [], status: 'active' };
      this.editModal = true;
    },
    showEdit(index) {
      const d = this.tableData[index];
      const rules = (d.rules || []).map(r => {
        const rt = JSON.parse(JSON.stringify(this.regionTreeAll || []));
        const selected = new Set((r.region || []));
        const mark = nodes => {
          (nodes || []).forEach(n => {
            if (selected.has(n.value)) n.checked = true;
            mark(n.children);
          });
        };
        mark(rt);
        return { type: r.type, url: r.url, priority: r.priority, regions: (r.region || []), regionTree: rt };
      });
      this.dataModel = { id: d.id, name: d.name, description: d.description, shortCode: d.shortCode || '', rules, status: d.status };
      this.editModal = true;
    },
    showDestroy(index) {
      this.destroyData = this.tableData[index];
      this.destroyModal = true;
    },
    destroy(result) {
      if (result && this.destroyData) {
        this.deleting = true;
        this.$http.delete(`admin/links/${this.destroyData.id}`).then(() => {
          this.$Message.success('删除成功!');
          this.refresh();
        }).finally(() => { this.deleting = false; });
      }
      this.destroyModal = false;
    },
    refresh() {
      if (this.currentPage) {
        this.changePage(this.currentPage);
      }
    },
    edit(result) {
      if (!result) return;
      this.$refs['dataModel'].validate((valid) => {
        if (!valid) { this.$Message.error('表单验证失败!'); return; }
        this.saving = true;
        const updateId = this.dataModel && this.dataModel.id;
        const payload = Object.assign({}, this.dataModel);
        delete payload.id;
        const collectChecked = (nodes) => {
          const res = [];
          (nodes || []).forEach(n => {
            if (n.checked) res.push(n.value);
            res.push(...collectChecked(n.children));
          });
          return res;
        };
        payload.rules = (payload.rules || []).map(r => ({ type: r.type, url: r.url, priority: r.priority || 0, region: r.type==='conditional' ? collectChecked(r.regionTree || []) : undefined }));
        
        // 如果短链不为空，则使用自定义短链
        if (payload.shortCode) {
          payload.shortCode = payload.shortCode.trim();
        } else {
          // 如果短链为空，则删除该字段，让后端生成随机短链
          delete payload.shortCode;
        }
        
        if (updateId) {
          this.$http.put(`admin/links/${updateId}`, payload).then(() => {
            this.$Message.success('编辑成功!'); this.refresh();
          }).catch(() => {
            this.$Message.warning('编辑失败');
          }).finally(() => { this.saving = false; });
        } else {
          this.$http.post('admin/links', payload).then(() => {
            this.$Message.success('新增成功!'); this.refresh();
          }).catch(() => {
            this.$Message.warning('新增失败');
          }).finally(() => { this.saving = false; });
        }
      });
    },
    addDefaultRule() {
      if (this.hasDefaultRule) return;
      this.dataModel.rules = this.dataModel.rules || [];
      this.dataModel.rules.push({ type: 'default', url: '', priority: 100 });
    },
    addConditionalRule() {
      this.dataModel.rules = this.dataModel.rules || [];
      const rt = JSON.parse(JSON.stringify(this.regionTreeAll || []));
      this.dataModel.rules.push({ type: 'conditional', regions: [], regionTree: rt, url: '', priority: 10 });
    },
    removeRule(idx) {
      this.dataModel.rules.splice(idx, 1);
    },
    expandAllRule(idx, expand) {
      const setExpand = (nodes) => {
        (nodes || []).forEach(n => {
          n.expand = expand;
          setExpand(n.children);
        });
      };
      const rule = this.dataModel.rules[idx];
      setExpand(rule.regionTree || []);
    },
    onRegionTreeChange(idx) {
      const rule = this.dataModel.rules[idx];
      const collectChecked = (nodes) => {
        const res = [];
        (nodes || []).forEach(n => {
          if (n.checked) res.push(n.value);
          res.push(...collectChecked(n.children));
        });
        return res;
      };
      rule.regions = collectChecked(rule.regionTree || []);
    },
    toggleStatus(index, enabled) {
      const item = this.tableData[index];
      const status = enabled ? 'active' : 'inactive';
      this.$http.put(`admin/links/${item.id}`, { status }).then(() => {
        this.$Message.success('状态已更新'); this.tableData[index].status = status;
      }).catch(() => {
        this.$Message.warning('状态更新失败');
      });
    },
    copyToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => this.$Message.success('已复制入口链接'));
      } else {
        const ta = document.createElement('textarea');
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); this.$Message.success('已复制入口链接'); } catch (e) { this.$Message.warning('复制失败'); }
        document.body.removeChild(ta);
      }
      try { window.localStorage.setItem('linkTipDismissed', '1'); this.dismissedTip = true; } catch (e) {}
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table-action-section {
  border-bottom: 1px solid #e9eaec;
  height: 32px;
  margin-bottom: 12px;
}
.rule-row { margin-top: 10px; }
.edit-modal-body { max-height: 70vh; overflow-y: auto; padding-right: 8px; }
</style>


// WEBPACK FOOTER //
// src/components/admin/Link.vue